// extracted by css-extract-rspack-plugin
var _1 = "ZrFl_C587lYOZ35_";
var _2 = "R3Wz7ihSuvQ3E9Sf";
export { _1 as "container", _2 as "duration" }
